import React, { useMemo } from "react";
import { getFeaturesToRender } from "../../utils/features.js";
import FareFeatureIcon from "../FareFeatureIcon/FareFeatureIcon.js";
import { Stack } from "@bookingcom/bui-react";
import { IconWithInclusionType } from "@flights/search-ui";
const FareFeatureIcons = ({ brandedFareInfo, isLarge, isCompact, includeSellableFeatures, isPreCheckAndPay, isTabularBFVariant = false, isTabularRow = false }) => {
    const { includedFeatures, nonBaggageFeatures } = useMemo(() => getFeaturesToRender(brandedFareInfo, {
        includeSellableFeatures,
        isTabularBFVariant,
        isPreCheckAndPay
    }), [brandedFareInfo, includeSellableFeatures, isPreCheckAndPay, isTabularBFVariant]);
    const includedBaggageFeatures = includedFeatures
        .filter((feature) => !nonBaggageFeatures.includes(feature))
        .filter((feature, index, self) => self.findIndex((f) => f.featureName === feature.featureName) === index);
    const featuresToShow = isTabularBFVariant ? includedBaggageFeatures : includedFeatures;
    const fareFeaturesIcons = featuresToShow.map(({ icon, featureName, availability }, index) => isTabularBFVariant ? (React.createElement(IconWithInclusionType, { svg: icon, inclusionType: "INCLUDED", attributes: { "aria-label": featureName }, key: index, size: isTabularRow ? "smaller" : "large" })) : (React.createElement(FareFeatureIcon, { key: featureName, icon: icon, isLarge: isLarge, availability: availability, inline: true })));
    if (!fareFeaturesIcons.length) {
        return null;
    }
    return (React.createElement(Stack, { attributes: { "data-testid": "FareFeaturesIcons" }, direction: "row", gap: isLarge ? 0 : isTabularBFVariant ? 1 : isCompact ? 0.5 : 2, alignItems: "center" }, fareFeaturesIcons));
};
export default FareFeatureIcons;
